import * as React from 'react';
import * as classNames from 'classnames';
import style from './dialog.less';
import * as $ from 'jquery';
import 'jquery-ui-bundle';
import '../../css/jquery-ui.css';
import '../../css/jquery-ui-etool.css';


export interface DialogButton {
    title: string;
    disabled?: boolean;
    autoFocus?: boolean;
    onClick(): void;
}

interface ModalDialogProps extends React.ClassAttributes<any> {
    buttons?: ReadonlyArray<DialogButton>;
    title?: string;
    className?: string;
    contentClassName?: string;
    canClose?: boolean;
    hasTitleBar?: boolean;
    closeOnOverlayClick?: boolean;
    displayContentBorder?: boolean;
    isOpen: boolean;
    width?: number | 'auto';
    height?: number | 'auto';
    fill?: boolean;
    onAfterClose?(): void;
    onAfterOpen?(): void;
    onResize?(size: any): void;
}

interface ModalDialogState {
    idPrefix: string;
}

export default class ModalDialog extends React.Component<ModalDialogProps, ModalDialogState> {
    public static defaultProps: Partial<ModalDialogProps> = {
        canClose: true,
        hasTitleBar: false,
        closeOnOverlayClick: false,
        displayContentBorder: false,
        buttons: [],
        width: 'auto',
        height: 'auto',
        fill: false
    };


    constructor(props: ModalDialogProps) {
        super(props);

        //  this.state = { idPrefix: _.uniqueId('modal_dialog_') };
    }
    private dialogContainer: HTMLDivElement;

    componentDidMount() {
        const dialogNode: any = $(this.dialogContainer.parentNode);
        dialogNode.dialog({
            autoOpen: this.props.isOpen,
            draggable: true,
            resizable: true,
            title: '', // this.props.title,
            width: this.props.width,
            height: this.props.height,
            minHeight: 400,
            modal: true,
            dialogClass: this.generateClasses(),
            position: { my: 'center top', at: 'center top+10', of: window },
            open: (event: any, ui: any) => {
                if (this.props.closeOnOverlayClick) {
                    $('.ui-widget-overlay').one('click', () => dialogNode.dialog('close'));
                }
                dialogNode.parents('.ui-dialog').first().find('.ui-dialog-titlebar-close').first().hide();  // Close-Button raus
                if (this.props.onAfterOpen) {
                    this.props.onAfterOpen();
                }
            },
            close: () => {
                if (this.props.onAfterClose) {
                    this.props.onAfterClose();
                }
            },
            resizeStop: (event: any, ui: any) => {
                if (this.props.onResize) {
                    this.props.onResize(ui.size);
                }
            }
        });
        //  buttons: this.generateButtons(), // War ein Attribut vom Dialog
        // Enable/Disable buttons
        this.updateButtons();
    }

    componentWillUnmount() {
        const dialogNode = $(this.dialogContainer.parentNode);

        ($(dialogNode) as any).dialog('destroy');
    }

    componentDidUpdate(previousProps: ModalDialogProps, previousState: ModalDialogState) {
        const dialogNode: any = $(this.dialogContainer.parentNode);

        if (previousProps.title !== this.props.title
            || previousProps.className !== this.props.className
            || previousProps.canClose !== this.props.canClose
            || previousProps.displayContentBorder !== this.props.displayContentBorder
            || previousProps.buttons !== this.props.buttons) {
            dialogNode.dialog('option', {
                title: this.props.title,
                dialogClass: this.generateClasses(),
                buttons: this.generateButtons(),
            });

            // Enable/Disable buttons
            this.updateButtons();
        }

        if (previousProps.isOpen !== this.props.isOpen) {
            // Show or hide dialog
            if (dialogNode.dialog('isOpen') && !this.props.isOpen) {
                dialogNode.dialog('close');
            } else if (!dialogNode.dialog('isOpen') && this.props.isOpen) {
                dialogNode.dialog('open');
            }
        }
    }

    render() {
        return (
            <div ref={(ref) => this.dialogContainer = ref}
                className={classNames(style.modalDialog, this.props.contentClassName)}>
                {this.props.children}
            </div>
        );
    }

    private generateButtons(): Array<any> {
        return new Array<any>();
    }

    private generateClasses(): string {
        return classNames(this.props.className, style.outerDialog, this.props.fill && style.fill,
            !this.props.canClose && style.noClose, this.props.displayContentBorder && style.contentBorder,
            !this.props.hasTitleBar && style.noTitleBar);
    }

    private updateButtons(): void {
    }
}
